
import React from "react";
import { Plus, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { 
  VehicleInfoSection, 
  AmenitiesSection, 
  AttestationSection 
} from "./VehicleFormSections";
import { useVehicleForm } from "./hooks/useVehicleForm";

export const VehicleRegistrationForm = () => {
  const {
    formProps,
    isSubmitting,
    toggleAmenity,
    handleSubmit,
    handleAddAnotherVehicle,
    navigate,
    continueButtonPath,
    continueButtonLoaded,
    setContinueButtonLoaded
  } = useVehicleForm();

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <VehicleInfoSection 
        vehicleMake={formProps.vehicleMake}
        setVehicleMake={formProps.setVehicleMake}
        vehicleType={formProps.vehicleType}
        setVehicleType={formProps.setVehicleType}
        vehicleColor={formProps.vehicleColor}
        setVehicleColor={formProps.setVehicleColor}
        vehicleYear={formProps.vehicleYear}
        setVehicleYear={formProps.setVehicleYear}
        vehicleCapacity={formProps.vehicleCapacity}
        setVehicleCapacity={formProps.setVehicleCapacity}
        licensePlate={formProps.licensePlate}
        setLicensePlate={formProps.setLicensePlate}
        licensePlateRegion={formProps.licensePlateRegion}
        setLicensePlateRegion={formProps.setLicensePlateRegion}
      />
      
      <AmenitiesSection 
        selectedAmenities={formProps.selectedAmenities}
        toggleAmenity={toggleAmenity}
      />
      
      <AttestationSection 
        attestation={formProps.attestation}
        setAttestation={formProps.setAttestation}
      />
      
      <Button
        type="button"
        variant="outline"
        className="w-full border-black bg-black text-white hover:bg-black/90"
        onClick={handleAddAnotherVehicle}
        disabled={isSubmitting}
      >
        {isSubmitting ? "Adding..." : "Add Another Vehicle"} {!isSubmitting && <Plus className="ml-1" size={16} />}
      </Button>
      
      <button
        type="submit"
        className="w-full flex justify-center items-center h-12 hover:opacity-90 transition-opacity disabled:opacity-50"
        disabled={isSubmitting}
      >
        {continueButtonPath ? (
          <img 
            src={continueButtonPath} 
            alt="Continue" 
            className="h-12 w-auto"
            onLoad={() => setContinueButtonLoaded(true)}
          />
        ) : (
          <div className="w-full bg-gradient-to-r from-green-400 to-green-500 hover:opacity-90 rounded-md flex items-center justify-center h-12">
            {isSubmitting ? "Submitting..." : "Continue"}
            {!isSubmitting && <ArrowRight className="ml-2" size={16} />}
          </div>
        )}
      </button>
      
      <div className="text-center">
        <Button
          type="button"
          variant="ghost"
          className="text-sm text-gray-500 hover:text-gray-800"
          onClick={() => navigate(-1)}
        >
          Go Back
        </Button>
      </div>
    </form>
  );
};
